import { Suspense, lazy } from 'react';

import type { FileWithPath } from 'react-dropzone';

import { useTheme } from '@pulse-web-ui/theme';

import { convertBytesToMb } from '../../../../utils';
import {
  File,
  FileInfo,
  IconContainer,
  Name,
  NameWrapper,
  RemoveIcon,
  Size,
} from './file-item.styles';

const Plus = lazy(() => import('@pulse-web-ui/icons/lib/lazy/close'));
const Document = lazy(
  () => import('@pulse-web-ui/icons/lib/lazy/document-transparent')
);

interface FileItemProps {
  file: FileWithPath;
  onRemove: (event: React.MouseEvent<Element, MouseEvent>) => void;
  testId?: string;
}

export const FileItem = ({
  file,
  onRemove,
  testId = 'file-item',
}: FileItemProps) => {
  const theme = useTheme();

  const size = convertBytesToMb(file.size).toFixed(2);
  const nameWithType = file.name.split('.');
  const type = nameWithType.pop() || '';
  const name = nameWithType.join('.');

  return (
    <File data-testid={`${testId}-file`}>
      <Suspense>
        <IconContainer>
          <Document
            color={theme.colors.icon.primary}
            width={24}
          />
        </IconContainer>
      </Suspense>
      <Suspense>
        <RemoveIcon
          onClick={onRemove}
          data-testid={`${testId}-remove-file`}
        >
          <Plus
            color={theme.colors.icon.primary}
            viewBox='0 0 24 24'
            width={16}
          />
        </RemoveIcon>
      </Suspense>
      <FileInfo>
        <NameWrapper>
          <Name>{name}</Name>
          {`.${type}`}
        </NameWrapper>
        <Size>{size} Мб</Size>
      </FileInfo>
    </File>
  );
};
